import React from 'react';
import { Spacer, Text } from '@ontruck/orc';

const Unassign = ({ changes: { driver_contact_name }, ...props }) => {
  return (
    <Spacer {...props}>
      <Text color="grey800" display="block">
        {driver_contact_name}
      </Text>
    </Spacer>
  );
};

export default Unassign;
